import { render, staticRenderFns } from "./Calc1Work.vue?vue&type=template&id=00d8e799&scoped=true&"
import script from "./Calc1Work.ts?vue&type=script&lang=ts&"
export * from "./Calc1Work.ts?vue&type=script&lang=ts&"
import style0 from "./Calc1Work.css?vue&type=style&index=0&id=00d8e799&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00d8e799",
  null
  
)

export default component.exports